import entityStoreReducer from './reducer';

export * from './actions';

export default entityStoreReducer;
